module.exports = __webpack_public_path__ + "img/cancel_b.38fd130c.png";